export enum AlertMessages {
    RequestInProgress = 'Kérés folyamatban...',
    SavedSuccessfully = 'Mentés sikeres.',
    UnknownErrorTryAgain = 'Ismeretlen hiba történt. Kérjük próbálja újra!',
    DeletedSuccessfully = 'Törlés sikeres.'
};